/**
 * 広告バナー
 */
export const BANNERS = [
  {
    imageUrl: '/images/ranking/banner/banner_01.jpg?v=2',
    targetUrl: 'https://nhktext.jp/haru2025_timeattack_site_adbanner_asahi',
    alt: '朝日新聞社',
  },
  {
    imageUrl: '/images/ranking/banner/banner_02.png?v=2',
    targetUrl: 'https://nhktext.jp/haru2025_timeattack_site_adbanner_nichibei',
    alt: '日米会話学院',
  },
  {
    imageUrl: '/images/ranking/banner/banner_03.jpg?v=2',
    targetUrl: 'https://nhktext.jp/haru2025_timeattack_site_adbanner_nhk-g',
    alt: 'NHKグローバルメディアサービス',
  },
  {
    imageUrl: '/images/ranking/banner/banner_04.jpg?v=2',
    targetUrl: 'https://nhktext.jp/haru2025_timeattack_site_adbanner_z-kai',
    alt: 'Z会書籍',
  },
] as const;

/**
 * 受験回数とキャラクターレベルの対応
 */
export const CHARACTER_EVOLUTION = [
  {
    examCount: 0,
    evolutionLevel: 1,
  },
  {
    examCount: 1,
    evolutionLevel: 2,
  },
  {
    examCount: 3,
    evolutionLevel: 3,
  },
  {
    examCount: 6,
    evolutionLevel: 4,
  },
  {
    examCount: 11,
    evolutionLevel: 5,
  },
  {
    examCount: 21,
    evolutionLevel: 6,
  },
  {
    examCount: 31,
    evolutionLevel: 7,
  },
  {
    examCount: 51,
    evolutionLevel: 8,
  },
] as const;

type CharacterInfoType = Record<
  number,
  {
    title: string;
    imageSize: { width: number; height: number };
  }
>;

/**
 * キャラクターのレベル別情報（タイトル、画像サイズ）
 */
export const CHARACTER_INFO: CharacterInfoType = {
  1: {
    title: '冒険見習いねずみ',
    imageSize: { width: 108, height: 116 },
  },
  2: {
    title: '目指すは勇者',
    imageSize: { width: 124, height: 116 },
  },
  3: {
    title: '気分は勇者',
    imageSize: { width: 108, height: 116 },
  },
  4: {
    title: 'ちょっと勇者',
    imageSize: { width: 134, height: 130 },
  },
  5: {
    title: '一人前の勇者',
    imageSize: { width: 132, height: 130 },
  },
  6: {
    title: 'エスパー勇者',
    imageSize: { width: 153, height: 130 },
  },
  7: {
    title: '立派な勇者',
    imageSize: { width: 153, height: 130 },
  },
  8: {
    title: '伝説の勇者',
    imageSize: { width: 216, height: 152 },
  },
};

export type EvolutionLevel =
  (typeof CHARACTER_EVOLUTION)[number]['evolutionLevel'];
